<div fxLayout="row " fxLayout="column" class="marcas-list-div">
  <mat-checkbox [checked]="marca.checked" *ngFor="let marca of marcaList$ | listFilter: 'VISIBLE': true"
    (change)="SetMarca(marca, $event)">{{marca.text}}</mat-checkbox>
</div>